import messages from '../../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../../helpers/FieldRestriction';

const validate = values => {

  const errors = {}

  if (!values.metaTitle) {
    errors.metaTitle = messages.required;
  } else if (values?.metaTitle?.trim() == "") {
    errors.metaTitle = messages.required;
  } else if (values?.metaTitle?.length > inputTextLimit) {
    errors.metaTitle = messages.inputTextLimitError;
  }

  if (!values.metaDescription) {
    errors.metaDescription = messages.required;
  } else if (values?.metaDescription?.trim() == "") {
    errors.metaDescription = messages.required;
  } else if (values?.metaDescription?.length > inputDescLimit) {
    errors.metaDescription = messages.inputDescLimitError;
  }

  if (!values.pageUrl) {
    errors.pageUrl = messages.required;
  } else if (values?.pageUrl?.trim() == "") {
    errors.pageUrl = messages.required;
  } else if (values?.pageUrl?.length > inputTextLimit) {
    errors.pageUrl = messages.inputTextLimitError;
  }
  else {
    var slashCount = (values.pageUrl.match(/\//g) || []).length;
    var questionCount = (values.pageUrl.match(/\?/g) || []).length;
    var andCount = (values.pageUrl.match(/\&/g) || []).length;
    if (slashCount >= 1 || questionCount >= 1 || andCount >= 1) {
      errors.pageUrl = messages.invalidUrl;
    }
  }

  if (!values.pageTitle) {
    errors.pageTitle = messages.required;
  } else if (values?.pageTitle?.trim() == "") {
    errors.pageTitle = messages.required;
  } else if (values?.pageTitle?.length > inputTextLimit) {
    errors.pageTitle = messages.inputTextLimitError;
  }

  if (values.content) {

    let errorContent = [];
    if (values?.content?.map((item, index) => {
      const dynamicContentError = {}
      let content = item?.content?.replace('<p>', '')?.replace('</p>', '');
      const stripped = item?.content?.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").replace(/\s+/g, "").trim();
      if (!item?.content || content.trim() === '' || !stripped) {
        dynamicContentError.content = messages.required;
        errorContent[index] = dynamicContentError;
      }
      if (!item?.language || item?.language.toString().trim() === '') {
        dynamicContentError.language = messages.required;
        errorContent[index] = dynamicContentError;
      }
    }));
    if (errorContent?.length > 0) errors.content = errorContent;
  }

  return errors;
}

export default validate;
